import { get } from '@core/Services/ApiService'
import type { BannerApiResource } from '../types'

export const fetchBannersFromApi = () =>
  get<BannerApiResource[]>({ url: '/api/contentful/banners' })
